/*=========================================================================================
  File Name: module-usertax-mutations.js
  Description: UserTax Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	UserList: [],
	userListLoaded: false,
	Total: 0,
	IsLoadingTotalRecords: false,
	Role: 1,
	TaxCode: null,
	user: null,
	userConfig: null,
	WorkPermission: [],
	JobTitles: [],
	CheckServeyUser: false,
	MWSTokenV2: {
		ExpiredDate: null,
		Token: null
	},
	featureTooltipConfig: []
};
